<template>
	<div class="">
		<div class="flex justc">
			<div class="">
				<div class="td">
					<div class="tdpy">技术评级</div>
					<div class="tdbg"></div>
				</div>
				<div class="jspj">
					<div class="js-num">82.56</div>
					<div class="js-desc">超过85.89%的同行业企业</div>
				</div>
			</div>
			<div class="" >
				<div class="td">
					<div class="tdpy">技术概览</div>
					<div class="tdbg"></div>
				</div>
				<div class="flex justc" style="margin: 10px 0;">
					<div class="">
						<div class="jsgl-num">
							<div class="">76</div>
						</div>
						<div class="jsgl-title">专利数量</div>
					</div>
					<div class="" style="margin-left: 40px;">
						<div class="jsgl-num">
							<div class="">76.9%</div>
						</div>
						<div class="jsgl-title">发明占比</div>
					</div>
				</div>
				<div class="flex justc">
					<div class="">
						<div class="jsgl-num">
							<div class="">1</div>
						</div>
						<div class="jsgl-title">软件著作</div>
					</div>
					<div class="" style="margin-left: 40px;">
						<div class="jsgl-num">
							<div class="">2</div>
						</div>
						<div class="jsgl-title">作品著作</div>
					</div>
				</div>
			</div>
		</div>
		<div class="flex justc">
			<div class="flexCol alit">
				<div class="td">
					<div class="tdpy">专利类型分类</div>
					<div class="tdbg"></div>
				</div>
			  <lsfzEcharts1Vue class="echarts1"></lsfzEcharts1Vue>
			</div>
			<div class="" >
				<div class="td">
					<div class="tdpy">专利申请趋势</div>
					<div class="tdbg"></div>
				</div>
				<lsfzEcharts2Vue class="echarts2"></lsfzEcharts2Vue>
			</div>
		</div>
	</div>
</template>

<script>
	import lsfzEcharts1Vue from './lsfzEcharts1.vue';
	import lsfzEcharts2Vue from './lsfzEcharts2.vue';
	export default {
		components: {
			lsfzEcharts1Vue,lsfzEcharts2Vue
		},
		data() {
			return {

			}
		},
		created() {

		},
		methods: {

		}
	}
</script>

<style scoped lang="scss">
	.echarts2{
		width: 200px;
		height: 130px;
	}
	.echarts1{
		width: 120px;
		height: 120px;
	}
	.jsgl-title {
		font-family: PingFang SC, PingFang SC;
		font-weight: 500;
		font-size: 11px;
		color: rgba(68, 193, 239, 1);
	}

	.jsgl-num {
		background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E7%BB%BF%E8%89%B2%E5%8F%91%E5%B1%95/%E6%8A%80%E6%9C%AF%E6%A6%82%E8%A7%88%E8%83%8C%E6%99%AF%402x.png');
		background-size: 55px 16px;
		background-repeat: no-repeat;
		background-position-y: 10px;

		div {
			font-family: DIN-BoldItalic, DIN-BoldItalic;
			font-weight: 900;
			font-size: 16px;
			font-style: italic;
			background: linear-gradient(90deg, #73AEFF 0%, #FEFEFF 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			margin-left: 5px;
		}
	}

	.jspj {
		background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E7%BB%BF%E8%89%B2%E5%8F%91%E5%B1%95/%E6%8A%80%E6%9C%AF%E8%AF%84%E7%BA%A7%E8%83%8C%E6%99%AF%402x.png');
		background-size: 100% 100%;
		width: 150px;
		height: 100px;

		.js-desc {
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 11px;
			color: #FFFFFF;
			text-align: center;
			margin-top: 10px;
		}

		.js-num {
			padding-top: 20px;
			font-family: DIN-BoldItalic, DIN-BoldItalic;
			font-weight: 900;
			font-size: 24px;
			color: #EDFBFF;
			text-align: center;
			font-style: italic;
			background: linear-gradient(90deg, #FFF600 21%, #FFFCA2 83%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}
	}

	.td {
		position: relative;
		margin-top: 15px;
		width: 200px;
		.tdpy {
			font-weight: normal;
			font-size: 12px;
			color: #E6EDF8;
			margin-top: -8px;
			position: absolute;
			left: 10px;
			font-style: italic;
		}

		.tdbg {
			width: 188px;
			height: 18px;
			background: linear-gradient(90deg, #3A61BB 0%, #29439D 100%);
			border-radius: 0px 0px 0px 0px;
		}
	}
</style>